import { defineMessages } from 'react-intl'

export default defineMessages({
  youWillReceiveEmail: {
    id: 'containers.UserSignIn.components.Forgot.youWillReceiveEmail',
    defaultMessage: 'You will recieve an e-mail shortly.',
  },
  goBack: {
    id: 'containers.UserSignIn.components.Forgot.goBack',
    defaultMessage: 'Go back',
  },
  enterUserName: {
    id: 'containers.UserSignIn.components.Forgot.enterUserName',
    defaultMessage: 'Enter your username or e-mail, and we\'ll send you a link to recover access to your',
  },
  account: {
    id: 'containers.UserSignIn.components.Forgot.account',
    defaultMessage: 'account',
  },
  userOrEmail: {
    id: 'containers.UserSignIn.components.Forgot.userOrEmail',
    defaultMessage: 'Username or e-mail address',
  },
  recovering: {
    id: 'containers.UserSignIn.components.Forgot.recovering',
    defaultMessage: 'Recovering..',
  },
  recoverMyAccount: {
    id: 'containers.UserSignIn.components.Forgot.recoverMyAccount',
    defaultMessage: 'Recover my account',
  },
  havingTrouble: {
    id: 'containers.UserSignIn.components.Forgot.havingTrouble',
    defaultMessage: 'Still having trouble?',
  },
  getInTouch: {
    id: 'containers.UserSignIn.components.Forgot.getInTouch',
    defaultMessage: 'Get in touch with us',
  },
})
